exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".location {\n  position: relative;\n}\n.location .am-list-item.am-input-item:after {\n  left: 0;\n  border-bottom: 1PX solid #DEE1E6;\n}\n.location .location__content {\n  position: absolute;\n  width: 100%;\n  height: 3.45rem;\n  overflow-y: auto;\n  z-index: 500;\n}\n.location__content-hidden {\n  display: none;\n}\n.location__list {\n  position: absolute;\n  width: 100%;\n  z-index: 190;\n}\n.location__map {\n  width: 100%;\n  height: 3.2rem;\n  overflow: hidden;\n  margin-top: 0.02rem;\n}\n.location__map .amap-logo {\n  display: none;\n}\n.location__map .amap-copyright {\n  display: none!important;\n}\n.locationMarker {\n  width: 100%;\n  height: 3rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./~/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#1DA57A"}}!./src/component/Location/Location.less
// module id = 593
// module chunks = 0